import { render } from "./CrossBorderRatesModal.vue?vue&type=template&id=31a38289&ts=true"
import script from "./CrossBorderRatesModal.vue?vue&type=script&lang=ts"
export * from "./CrossBorderRatesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__